import React from 'react';
import PropTypes from 'prop-types';

PrivacyPolicy.propTypes = {

};

function PrivacyPolicy() {
    return (
        <div className="privacy-policy">
            <h2>Privacy Policy</h2>
            <p>This Privacy Policy outlines how we collect, use, and safeguard your information when you use our game.</p>
            <p><strong>Information We Collect</strong></p>
            <p>We do not collect any personal information directly from our users. However, we utilize the following third-party services, which may collect certain data:</p>
            <ul>
                <li>Unity Authentication</li>
                <li>Unity Leaderboard</li>
                <li>Unity Ads</li>
            </ul>
            <p>For more information on how Unity uses the collected data please check <a href="https://unity.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">here</a>.</p>
            <p>By using Crypto Coin Trader, you signify your acceptance of our Privacy Policy.</p>
            <p>Last updated: 2024/03/26</p>
            <p>If you have any questions or concerns about our Privacy Policy, please contact us at <a href="mailto:codeItRalf@gmail.com">codeItRalf@gmail.com</a>.</p>
        </div>
    );
}

export default PrivacyPolicy;